module.exports = __webpack_public_path__ + "img/window.750c1e75.svg";